// extracted by mini-css-extract-plugin
export default {"wrapper":"Hero-module--wrapper--1ANYh","container":"Hero-module--container--1HBt8","title":"Hero-module--title--1YAto","subtitle":"Hero-module--subtitle--2TM5U"};